import React, { useContext, useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Row, Form } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller, SubmitHandler, Resolver } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { RoomService } from "./service";
import { FlatService } from "../flats/service";
import { ErrorToast, SuccessToast } from "../../shared/toasters/toasters";
import { limitToTwoDecimals } from "../../shared/utils/functions";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import FormDropzone from "../../shared/dropzone";
import { RoomNameService } from "../room-names/service";
import { IRoomName } from "../../shared/interfaces/room/IRoomName";
import { MaterialService } from "../materials/service";
// import { FloorTypeService } from "../floor-type/service";
// import { SkirtingBoardService } from "../skirting-board/service";
import { EnumsContext } from "../../context/EnumsContext";
import { useUnsavedChanges } from "../../shared/hooks/useUnsavedChanges";

const schema = yup
  .object()
  .shape({
    flatId: yup.number().required("validation.required"),
    roomNameId: yup.number().notRequired(),
    name: yup.string().notRequired(),
    size: yup.number().notRequired(),
    floorType: yup.number().notRequired(),
    floorOrientation: yup.string().notRequired(),
    material: yup.number().notRequired(),
    secondFloorType: yup.number().notRequired(),
    skirtingBoard: yup.number().notRequired(),
    skirtingBoardSize: yup.number().notRequired(),
    floorLevel: yup.number().notRequired(),
    currentState: yup.string().notRequired(),
    note: yup.string().notRequired(),
  })
  .test("name-or-roomNameId", "validation.required", function (value) {
    const { roomNameId, name } = value;
    if (!roomNameId && !name) {
      return this.createError({
        path: "roomNameId",
        message: "validation.required",
      });
    }
    return true;
  });

export interface IRoom {
  id?: number;
  flatId?: number;
  roomNameId?: number;
  name?: string;
  size?: number;
  floorType?: number;
  floorOrientation?: string;
  material?: number;
  secondFloorType?: number;
  skirtingBoard?: number;
  skirtingBoardSize?: number;
  floorLevel?: number;
  currentState?: string;
  note?: string;
  documents?: File[];
  roomName?: {
    name?: string;
  };
}

const RoomForm: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const isEdit = Boolean(id);
  const { enums } = useContext(EnumsContext);
  const [roomData, setRoomData] = useState<IRoom | null>(null);
  const [flatOptions, setFlatOptions] = useState<
    { value: number; label: string }[]
  >([]);

  const [roomNames, setRoomNames] = useState<
    { value: number; label: string }[]
  >([]);
  // const [floorTypes, setFloorTypes] = useState<
  //   { value: number; label: string }[]
  // >([]);
  // const [skirtingBoards, setSkirtingBoards] = useState<
  //   { value: number; label: string }[]
  // >([]);
  const [existingFiles, setExistingFiles] = useState<any[]>([]);
  const [documents, setDocuments] = useState<File[]>([]);
  // const [showSecondFloorType, setShowSecondFloorType] =
  //   useState<boolean>(false);
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors, isDirty },
  } = useForm<IRoom>({
    resolver: yupResolver(schema) as Resolver<IRoom>,
    defaultValues: {
      roomNameId: undefined,
      name: undefined,
      flatId: undefined,
      size: undefined,
      // floorType: undefined,
      // floorOrientation: undefined,
      // secondFloorType: undefined,
      // skirtingBoard: undefined,
      // skirtingBoardSize: undefined,
      floorLevel: undefined,
      currentState: "",
      note: "",
      documents: [],
    },
  });

  const { guardedNavigate, unsavedChangesModal } = useUnsavedChanges(isDirty);

  // const watchFloorType = watch("floorType");

  console.log(existingFiles, "existing files");
  // Fetch flats for select
  useEffect(() => {
    const fetchFlats = async () => {
      try {
        const res = await FlatService.getAll({ page: 1, perPage: 100 });
        setFlatOptions(
          res.data.map((flat: any) => ({
            value: flat.id,
            label: flat.name,
          })),
        );
      } catch (e) {
        ErrorToast(e);
      }
    };
    fetchFlats();
  }, []);

  useEffect(() => {
    RoomNameService.getAll({ page: 1, perPage: 100 })
      .then((response) => {
        setRoomNames(
          response.data.map((roomName: IRoomName) => ({
            value: roomName.id,
            label: roomName.name,
          })),
        );
      })
      .catch(ErrorToast);
  }, []);

  // // Fetch floor types
  // useEffect(() => {
  //   FloorTypeService.getAll({ page: 1, perPage: 100 })
  //     .then((response) => {
  //       setFloorTypes(
  //         response.data.map((item: any) => ({
  //           value: item.id,
  //           label: item.name,
  //         })),
  //       );
  //     })
  //     .catch(ErrorToast);
  // }, []);

  // // Fetch skirting boards
  // useEffect(() => {
  //   SkirtingBoardService.getAll({ page: 1, perPage: 100 })
  //     .then((response) => {
  //       setSkirtingBoards(
  //         response.data.map((item: any) => ({
  //           value: item.id,
  //           label: item.name,
  //         })),
  //       );
  //     })
  //     .catch(ErrorToast);
  // }, []);

  // Fetch room data if editing
  useEffect(() => {
    if (isEdit) {
      const fetchRoom = async () => {
        try {
          const response = await RoomService.getSingle(+id!);
          setRoomData({
            flatId: response.flat?.id,
            roomNameId: response.roomName?.id,
            name: response.name || undefined,
            size: response.size,
            // floorType: response.floorType?.id,
            // floorOrientation: response.floorOrientation,
            material: response.material?.id,
            // secondFloorType: response.secondFloorType?.id,
            // skirtingBoard: response.skirtingBoard?.id,
            // skirtingBoardSize: response.skirtingBoardSize,
            floorLevel: response.floorLevel,
            currentState: response.currentState || "",
            note: response.note || "",
            documents: [],
          });
          // Show second floor type field if it has a value
          // if (response.secondFloorType?.id) {
          //   setShowSecondFloorType(true);
          // }
          // If you want to show existing documents, set them here:
          setExistingFiles(response.files);
        } catch (error) {
          ErrorToast(error);
        }
      };
      fetchRoom();
    }
  }, [isEdit, id]);

  useEffect(() => {
    if (roomData) {
      reset(roomData);
    }
  }, [roomData, reset]);

  // Handle file uploads from dropzone
  const handleFileUpload = (files: File[]) => {
    setDocuments(files);
    setValue("documents", files, { shouldDirty: true });
  };

  const onSubmit: SubmitHandler<IRoom> = async (data) => {
    try {
      const formData = new FormData();

      // Everything except documents goes under "body"
      const { documents, ...rest } = data;
      formData.append("body", JSON.stringify(rest));

      // Append files as "documents"
      if (documents && documents.length > 0) {
        documents.forEach((file) => {
          formData.append("documents", file);
        });
      }

      if (isEdit) {
        await RoomService.update(formData, +id!);
      } else {
        await RoomService.create(formData);
      }
      SuccessToast(t(`room.${isEdit ? "successUpdate" : "successCreate"}`));
      navigate("/rooms");
      reset();
    } catch (error) {
      ErrorToast(error);
    }
  };

  return (
    <React.Fragment>
      <Row>
        <Col sm={12}>
          <Card>
            <CardBody>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Row className="g-3">
                  <Col sm={12}>
                    <h5>{t("room.roomInformation")}</h5>
                  </Col>
                  <Col sm={12} xl={4}>
                    <Form.Label className="required">
                      {t("room.name")}
                    </Form.Label>
                    <Controller
                      name="roomNameId"
                      control={control}
                      render={({
                        field: { onChange: onChangeRoomId, value: roomIdValue },
                      }) => (
                        <Controller
                          name="name"
                          control={control}
                          render={({
                            field: { onChange: onChangeName, value: nameValue },
                          }) => {
                            // Display value: show custom name or selected room name
                            const displayValue = nameValue
                              ? { label: nameValue, value: nameValue }
                              : roomIdValue
                                ? roomNames
                                  .filter((r) => r?.value === roomIdValue)
                                  .map((r) => ({
                                    label: r?.label || "",
                                    value: r?.value,
                                  }))[0] || null
                                : null;

                            return (
                              <>
                                <CreatableSelect
                                  classNamePrefix="react-select"
                                  className={`react-select-container ${errors.roomNameId ? "is-invalid" : ""}`}
                                  options={roomNames}
                                  value={displayValue}
                                  onChange={(selected) => {
                                    if (selected) {
                                      const selectedValue = selected.value;

                                      // Check if it's an existing room (number value) or custom (string)
                                      if (typeof selectedValue === "number") {
                                        onChangeRoomId(selectedValue);
                                        onChangeName(undefined); // Clear custom name
                                      } else {
                                        // Custom value - extract the actual string
                                        let customName: any = selectedValue;

                                        // Remove any JSON stringification artifacts
                                        if (typeof customName === "string") {
                                          try {
                                            // Try to parse if it's a JSON string
                                            customName = JSON.parse(customName);
                                          } catch {
                                            // If parsing fails, use as-is
                                          }
                                        }

                                        onChangeRoomId(undefined); // Clear roomNameId
                                        onChangeName(String(customName)); // Ensure it's a string
                                      }
                                    } else {
                                      onChangeRoomId(undefined);
                                      onChangeName(undefined);
                                    }
                                  }}
                                  onCreateOption={(inputValue) => {
                                    // When user creates a new option
                                    let customName: any = inputValue;

                                    // Remove any JSON stringification artifacts
                                    if (typeof customName === "string") {
                                      try {
                                        customName = JSON.parse(customName);
                                      } catch {
                                        // If parsing fails, use as-is
                                      }
                                    }

                                    onChangeRoomId(undefined); // Clear roomNameId
                                    onChangeName(String(customName)); // Set custom name as string
                                  }}
                                  placeholder={t("room.selectRoomName")}
                                  isClearable
                                  createOptionPosition="last"
                                  formatCreateLabel={(inputValue) =>
                                    t("room.addCustomRoomName", {
                                      name: inputValue,
                                    })
                                  }
                                />
                                {errors.roomNameId && (
                                  <div className="invalid-feedback d-block">
                                    {t("validation.required")}
                                  </div>
                                )}
                              </>
                            );
                          }}
                        />
                      )}
                    />
                  </Col>
                  <Col sm={12} xl={4}>
                    <div className="mb-0">
                      <Form.Label className="required">
                        {t("room.flat")}
                      </Form.Label>
                      <Controller
                        name="flatId"
                        control={control}
                        render={({ field }) => (
                          <Select
                            classNamePrefix="react-select"
                            className={`react-select-container ${errors.flatId ? "is-invalid" : ""}`}
                            options={flatOptions}
                            value={
                              flatOptions.find(
                                (option) => option.value === field.value,
                              ) || null
                            }
                            onChange={(option) =>
                              field.onChange(option ? option.value : undefined)
                            }
                            placeholder={t("room.selectFlat")}
                            isClearable
                          />
                        )}
                      />
                      {errors.flatId && (
                        <div className="invalid-feedback">
                          {t("validation.required")}
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col sm={12} xl={4}>
                    <div className="mb-0">
                      <label className="form-label">{t("room.size")}</label>
                      <Controller
                        name="size"
                        control={control}
                        render={({ field }) => (
                          <input
                            type="number"
                            step="0.01"
                            className={`form-control ${errors.size ? "is-invalid" : ""}`}
                            placeholder={t("room.enterSize")}
                            value={field.value ?? ""}
                            onChange={(e) => {
                              const limited = limitToTwoDecimals(
                                e.target.value,
                              );
                              field.onChange(
                                limited === "" ? undefined : Number(limited),
                              );
                            }}
                          />
                        )}
                      />
                      {errors.size && (
                        <div className="invalid-feedback">
                          {errors.size.message}
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col sm={12}>
                    <div className="mb-0">
                      <label className="form-label">{t("room.note")}</label>
                      <Controller
                        name="note"
                        control={control}
                        render={({ field }) => (
                          <textarea
                            className="form-control"
                            placeholder={t("location.enterNote")}
                            {...field}
                          />
                        )}
                      />
                    </div>
                  </Col>
                  <Col sm={12}>
                    <h5>{t("room.currentStateTitle")}</h5>
                  </Col>
                  <Col sm={12} xl={4} className="d-flex align-items-end">
                    <div className="mb-0 flex-grow-1">
                      <label className="form-label">
                        {t("room.floorLevel")}
                      </label>
                      <Controller
                        name="floorLevel"
                        control={control}
                        render={({ field }) => (
                          <input
                            type="number"
                            step="1"
                            className="form-control"
                            placeholder={t("room.enterFloorLevel")}
                            value={field.value ?? ""}
                            onChange={(e) =>
                              field.onChange(
                                e.target.value === ""
                                  ? undefined
                                  : Number(e.target.value),
                              )
                            }
                          />
                        )}
                      />
                    </div>
                  </Col>
                  {/* showSecondFloorType button and field removed */}

                  {/* skirtingBoard and skirtingBoardSize fields removed */}
                  <Col sm={12}>
                    <div className="mb-0">
                      <label className="form-label">
                        {t("room.currentState")}
                      </label>
                      <Controller
                        name="currentState"
                        control={control}
                        render={({ field }) => (
                          <textarea
                            className="form-control"
                            placeholder={t("room.enterCurrentState")}
                            {...field}
                          />
                        )}
                      />
                    </div>
                  </Col>
                  {/* floorType, floorOrientation, and workToBeDone section removed */}

                  <Col sm={12}>
                    <div className="mb-0">
                      <label className="form-label">
                        {t("room.documents")}
                      </label>
                      <FormDropzone
                        onFileUpload={handleFileUpload}
                        existingFiles={existingFiles}
                        multiple={true}
                        accept="*"
                      />
                    </div>
                  </Col>
                  <Col sm={12} className="d-flex gap-2">
                    <Button type="submit" variant="primary">
                      {t(`room.${isEdit ? "update" : "create"}`)}
                    </Button>
                    <Button type="button" variant="secondary" onClick={() => guardedNavigate("/rooms")}>
                      {t("button.cancel")}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {unsavedChangesModal}
    </React.Fragment>
  );
};

export default RoomForm;
